// Third-party Library 
import React, { useState, useEffect, useRef } from "react"
import { useSelector } from "react-redux";
import { Modal } from "antd";
import Draggable from 'react-draggable';

// Components
import CameraBox from "./components/CameraBox";
import CameraActionButtons from "./components/CameraActionButtons";
import PlayActionButtons from "./components/PlayActionButtons";

// Service
import { REDUX as REDUX_UTIL, TIME } from "../../../../services/util"

// Styles
import './index.css'

const {
    reduxStoreWrapper
} = REDUX_UTIL

const LiveCameraPopup = () => {

    const { 
        isLive,
        attachments,
        selectedMDVRID,
        user
    } = useSelector(reduxStoreWrapper('liveCamera'))
    const devices = useSelector(reduxStoreWrapper('devicesMDVR'))
    
    const channelNumTest = devices.stateByID[selectedMDVRID]?.ChannelNumber

    const [ camLen, setCamLen ] = useState(3)
    const [ isDragged, setIsDragged ] = useState(false)
    const [ next, setNext ] = useState(0)
    const [ times, setTimes ] = useState({})
    const [ refCam, setRefCam ] = useState(null)

    // Get Seconds
    useEffect(() => {
        const video = refCam?.current
        if (!video) return;
      
        const timeUpdateInterval = setInterval(() => {
            const currentSeconds = video.currentTime;
            const duration = video.duration

            setTimes({
                minsec: TIME.parseSeconds(currentSeconds),
                seconds: currentSeconds,
                duration: duration,
                percentage: (currentSeconds / duration)
            })

        }, 1000)
      
        return () => clearInterval(timeUpdateInterval)
    }, [refCam?.current]);
    
    const prevNext = next * (camLen * camLen)
    const thisNext = prevNext + (camLen * camLen)
    
    const data = 
        !isLive ?
            attachments?.map((attachment, i) => ({
                url: `https://202.126.209.190:8085/PlayBackOnline/${attachment.filename}?seek=0&filepath=${attachment.filepath}`,
                label: `CH${i}`
            }))
            :
            channelNumTest && (Array.from({ length: channelNumTest.length > 9 ? channelNumTest : 9  }).map((_, i) => ({
                // url: `wss://202.126.209.190:8084/OpenDeviceStream/100?DeviceId=${selectedMDVRID}&ChannelId=${i}&seek=0&TimeOffset=0&n=0`,
                url: `wss://202.126.209.190:8084/OpenDeviceStream/100?DeviceId=${selectedMDVRID}&ChannelId=${i}&UserName=${user.UserName}&SessionId=${user.SessionId}&n=2`,
                label: `CH${i}`
        }))) || []


    useEffect(() => {
        if(data.length === 1) {
            setCamLen(1)
        }
    }, [data])

    const setCamLenHDLR = (num) => {
        setCamLen(num); 
        setNext(0)
    }

    
    /** ---------------- DRAG ---------------- */
    const dragRef = useRef(null);
    const [bounds, setBounds] = useState({ left: 0, top: 0, right: 0, bottom: 0 });

    const onDragStart = (_e, uiData) => {
        if(!isDragged) return

        const { clientWidth, clientHeight } = document.documentElement;
        const rect = dragRef.current?.getBoundingClientRect();

        if (!rect) return;

        setBounds({
            left: -rect.left + uiData.x,
            right: clientWidth - (rect.right - uiData.x),
            top: -rect.top + uiData.y,
            bottom: clientHeight - (rect.bottom - uiData.y),
        });
    };


    /** ---------------- RESIZE ---------------- */
    const [size, setSize] = useState({ width: 800, height: 500 });

    const resizeRef = useRef({ startX: 0, startY: 0, startW: 0, startH: 0 });

    const startResize = (e) => {
        if(!isDragged) return 

        e.stopPropagation();

        resizeRef.current = {
            startX: e.clientX,
            startY: e.clientY,
            startW: size.width,
            startH: size.height,
        };

        window.addEventListener("mousemove", onResizeMove);
        window.addEventListener("mouseup", stopResize);
    };

    const onResizeMove = (e) => {
        const { startX, startY, startW, startH } = resizeRef.current;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        setSize({
            width: Math.min(1200, Math.max(500, startW + dx)),
            height: Math.min(900, Math.max(300, startH + dy)),
        });
    };

    const stopResize = () => {
        window.removeEventListener("mousemove", onResizeMove);
        window.removeEventListener("mouseup", stopResize);
    };

    useEffect(() => {
        return () => {
            window.removeEventListener("mousemove", onResizeMove);
            window.removeEventListener("mouseup", stopResize);
        }
    }, [])

    return selectedMDVRID &&
        <Modal
            open={true}
            closable={false}
            footer={false}
            className='container-livecam'
            destroyOnClose
            modalRender={(modal) => (
                    <Draggable
                        handle=".modal-drag-handle"
                        cancel=".resize-handle"
                        disabled={!isDragged}
                        bounds={bounds}
                        nodeRef={dragRef}
                        onStart={onDragStart}
                    >
                        <div
                            ref={dragRef}
                            style={{ width: size.width, height: size.height }}
                        >
                            {modal}
                        </div>
                    </Draggable>
            )}
        >
            
            <div className="modal-drag-handle" style={{ cursor: 'pointer' }}>
                <CameraActionButtons 
                    setCamLenHDLR={setCamLenHDLR}
                    camLen={camLen}
                    deviceMDVR={devices.stateByID[selectedMDVRID]}
                    setIsDragged={setIsDragged} isDragged={isDragged}
                />
            </div>

            <div 
                style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${camLen}, 1fr)`,
                    gridTemplateRows: `repeat(${camLen}, 1fr)`,
                    gap: '2px',
                    backgroundColor: 'black',
                    border: '2px solid #222',
                    width: '100%',
                    height: size.height,
                    minHeight: 480
                }}
            >
                {
                    data.slice(prevNext, thisNext)?.map((data, i) => 
                        <CameraBox url={data.url} label={data.label} 
                            key={i}
                            isLive={isLive}
                            onClick={(ref) => {
                                setCamLen(1)
                                setNext(i)
                                setRefCam(ref)
                            }}
                        />
                    )
                }
            </div>

            <PlayActionButtons
                videoRef={refCam}
                isLive={isLive}
                times={times}
                setNext={setNext}
                dataLen={data.length}
                thisNext={thisNext}
                prevNext={prevNext}
            />

            {
                isDragged
                &&
                <div 
                    aria-hidden='true' 
                    style={{ 
                        height: 16,
                        width: 16,
                        cursor: 'nwse-resize',
                        position: 'absolute',
                        bottom: 0,
                        right: 0
                    }} 
                    onMouseDown={startResize}
                />
            }

        </Modal>
}

export default React.memo(LiveCameraPopup)